export default __webpack_public_path__ + "static/media/solution-Banner.1cfb346c.png";